export const MAESTRO = Object.freeze({
    TIPO_DOCUMENTO: 'mst_tipo_documento',
});